import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { dynamicSetup } from '@/mixins/dynamic-setup';
import { defaultItem } from '../new-item';

export default Vue.component('add-item', {
  template: require('./template.html'),
  name: 'add-item',
  mixins: [guid, dynamicSetup],
  computed: {
    ...mapGetters([
      'currentSite',
      'activeSiteType',
    ]),
  },
  props: [
    'item-modal',
    'content',
    'dynamic-data',
  ],
  data() {
    return {
      name: '',
      addError: false,
    };
  },
  watch: {
    content(type) {
      this.addError = false;
      if (!type) {
        this.name = '';
      }
    },
    itemModal() {
      this.name = '';
      this.addError = false;
    },
  },
  methods: {
    async addItem() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.addError = false;
          try {
            this.$emit('set-loading', true);
            let newItem = defaultItem();
            newItem[this.dynamicData.newAddVal] = this.name;
            newItem._id = this.guid();
            const itemShape = {};
            _.forOwn(this.dynamicData.itemData, (s, key) => {
              itemShape[key] = s.value;
            });
            newItem = Object.assign(_.cloneDeep(itemShape), newItem);
            // add to state
            if (this.noDynamicData(this.activeSiteType)) {
              this.dynamicSetup(this.activeSiteType);
            }
            this.$store.dispatch('pushDropletVal', {
              array: this.currentSite.dynamic[this.activeSiteType].items,
              val: newItem,
            });
            await this._SEND([{
              name: 'updateSiteAttr',
              payload: {
                siteId: this.currentSite._id,
                attr: 'dynamic',
                value: this.currentSite.dynamic,
              },
            }]);
            this.$log.debug('successfully added new item: ', newItem);
            this.$emit('set-active-item', newItem);
            this.$emit('set-content', 'edit-item');
            this.$store.dispatch('addNotification', {
              id: this.guid(),
              type: 'success',
              time: 2000,
              message: 'Item added successfully!',
            });
          } catch (e) {
            this.$log.error(e);
            this.addError = e.message || e;
            await this._reportError({
              error: e,
              fn: 'addItem',
            });
          } finally {
            this.$emit('set-loading', false);
          }
        }
      });
    },
    startCase(word) {
      return _.startCase(word);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/add-item/index.js